import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { K1DataUploadTable } from "./table";
import { K1DataUploadEdit } from "./edit";

export default function K1DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Data upload");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K1DataUploadEdit />} />
      <Route index element={<K1DataUploadTable />} />
    </Routes>
  );
}
